import React, { useEffect, useState } from 'react';

import Image from 'next/image';

import { motion } from 'framer-motion';
import { v4 as uuidv4 } from 'uuid';

import { core } from '../localization/core';

const getRandomCard = () => {
  const randomIndex = Math.floor(Math.random() * 3);
  return core.options[randomIndex].name;
};

const Game = ({ setShow }: { setShow: (show: boolean) => void, }) => {
  const [cardSelected, setCardSelected] = useState('');
  const [initialCard, setInitialCard] = useState('');
  const [loseState, setLoseState] = useState(false);
  const [loseSound, setLoseSound] = useState<HTMLAudioElement | null>(null);
  const [winSound, setWinSound] = useState<HTMLAudioElement | null>(null);

  useEffect(() => {
    const lose = new Audio('/img/v2/sound/lose.mp3');
    const win = new Audio('/img/v2/sound/win.mp3');

    setLoseSound(lose);
    setWinSound(win);
    setInitialCard(getRandomCard());
  }, []);

  const handleCardClick = (optionName: string) => {
    setCardSelected(optionName);

    if (optionName === initialCard) {
      winSound?.play();
      setShow(true);
      setLoseState(false);
    } else {
      setLoseState(true);
      loseSound?.play();
      setCardSelected('');
      setInitialCard(getRandomCard());
    }
  };

  return (
    <div className="flex flex-col items-center justify-center mt-7">
      <div className="flex items-stretch justify-center ">
        {core.options.map((option) => {
          return (
            <motion.div
              className="relative w-32 h-32 cursor-pointer"
              animate={{ rotateY: cardSelected === option.name ? 180 : 0 }}
              key={uuidv4()}
              transition={{ duration: 0.6 }}
              style={{ transformStyle: 'preserve-3d' }}
              whileTap={{ scale: 0.95 }}
              onTap={() => { return handleCardClick(option.name); }}
            >
              {/* Front */}
              <div
                className="absolute inset-0 flex items-center justify-center"
                style={{ backfaceVisibility: 'hidden' }}
              >
                <Image
                  src={option.imageWhite}
                  alt={option.name}
                  width={100}
                  height={100}
                  unoptimized
                  data-testid="next-image-mock"
                />
              </div>

              {/* Back */}
              <div
                className="absolute inset-0"
                style={{
                  backfaceVisibility: 'hidden',
                  transform: 'rotateY(180deg)',
                }}
              >
                <Image
                  src={option.image}
                  alt={option.id}
                  width={100}
                  height={100}
                  unoptimized
                  data-testid="next-image-mock"
                />
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-4 text-center bg-linear-to-r from-yellow-400 to-amber-500 px-9 py-1 text-2xl font-bold text-sivarbet-background">
        {initialCard}
      </div>
      {loseState ? <p className="text-white text-lg font-medium mt-5">{core.lose}</p> : <p className="text-white text-sm font-medium mt-5">{core.gains}</p>}
    </div>
  );
};

export default Game;
